export const seoConfig = {
  baseUrl: 'https://nepaliname.abh.com.np',
  defaultTitle: 'Nepali Baby Name - Discover Nepali Name Meanings',
  defaultDescription: 'Find meanings of Nepali names, explore baby names, and learn about Nepali naming traditions.',
  defaultKeywords: 'nepali names, name meanings, nepali baby names, name origin, name significance, nepali culture',
  defaultImage: 'https://nepaliname.abh.com.np/og-image.jpg',
  siteName: 'nepaliname',
  locale: 'en_US',
  twitterHandle: '@nepaliname',
  themeColor: '#7c3aed',
  
  // Schema.org configuration
  organization: {
    name: 'nepaliname',
    url: 'https://nepaliname.abh.com.np',
    logo: 'https://nepaliname.abh.com.np/logo.png',
    sameAs: [
      'https://facebook.com/nepaliname',
      'https://twitter.com/nepaliname'
    ]
  },
  
  // Structured data defaults
  structuredData: {
    type: 'WebSite',
    name: 'nepaliname',
    description: 'Find meanings of Nepali names and explore baby names',
    url: 'https://nepaliname.abh.com.np'
  }
} as const;